<script setup lang="ts">

import LayoutOrderService from "~/components/layouts/page/order/LayoutOrderService.vue";
import ConfirmAddressGray from "~/components/component/Service/order/forms/address/ConfirmAddressGray.vue";
import AddressManager from "~/components/component/Address/AddressManager.vue";

const {t} = useI18n()
const props = defineProps({
  isFilled: Boolean,
  hide: Boolean,
  order: Number
})
const addresses = useStoreAddresses()
const storeSelectedAddress = useStoreSelectedAddress()
const selectedAddressError = ref({
  show: false,
  text:  t('errors.address.choose_one')
})
const addressManagerRef = ref(null)

const emit = defineEmits(['next', 'back'])

async function goNext() {
  const isOk = await addressManagerRef.value.onNext()
  if (!isOk) {
    return
  } else if (!storeSelectedAddress.value) {
    selectedAddressError.value.show = true
    return
  } else {
    selectedAddressError.value.show = false
  }
  emit('next')
}

function goBack() {
  emit('back', props.order)
}

</script>

<template>
  <LayoutOrderService
      :is-filled="isFilled"
      :hide="hide"
      :order="order"
      :text="`3. ${$t('order_page.titles.cleaning_address')}`"
      @back="goBack"
      @next="goNext"
  >
    <template #filled>
      <ConfirmAddressGray
          :address="storeSelectedAddress"
          v-if="isFilled"/>
    </template>
    <template #input>
        <span v-if="selectedAddressError.show"
              class="order-service-form-error">
        {{ selectedAddressError.text }}
      </span>
        <AddressManager ref="addressManagerRef" :show-save-button="false" @back="goBack"/>
    </template>
  </LayoutOrderService>
</template>

<style scoped>

</style>